// A2F-650: small on/off switch used by the Step 3 pack list.
//
// Standalone (not the one in components/PackRail.tsx) because the FRE
// version takes an accent so the FREE pack row's switch reads green
// while PRO rows read brand-orange — same visual rule the row's left
// border uses. PackRail's Toggle stays orange-only and untouched.

interface ToggleProps {
  on: boolean
  disabled?: boolean
  accent?: 'orange' | 'green'
  onClick?: () => void
  ariaLabel: string
}

export function Toggle({
  on,
  disabled = false,
  accent = 'orange',
  onClick,
  ariaLabel,
}: ToggleProps) {
  const onColor = accent === 'green' ? 'bg-emerald-700' : 'bg-brand-orange'
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      className={`relative h-5 w-9 rounded-full transition-colors shrink-0 disabled:opacity-60 disabled:cursor-not-allowed ${
        on ? onColor : 'bg-slate-300'
      }`}
    >
      <span
        className="absolute top-0.5 h-4 w-4 rounded-full bg-white shadow transition-transform"
        style={{ left: on ? '18px' : '2px' }}
      />
    </button>
  )
}
